const { render, useState } = wp.element;
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { LightenDarkenColor } from "lighten-darken-color";
import ReactHtmlParser from "react-html-parser";
import { Upload } from "tus-js-client";
import axios from "axios";
import Cookies from "js-cookie";

//Import Designs
import {
    Typography,
    Grid2,
    FormControl,
    Select,
    MenuItem,
    TextField,
    InputLabel,
    FormLabel,
    TextareaAutosize,
    RadioGroup,
    FormControlLabel,
    Radio,
    Checkbox,
    Button,
    Icon,
    LinearProgress,
    CardMedia,
    Box,
    DialogActions,
    Dialog,
    DialogTitle as MuiDialogTitle,
    DialogContent as MuiDialogContent,
    IconButton,
    Backdrop,
    CircularProgress,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import JoditEditor from "jodit-react";

//Action to save and fetch data
import {
    SubmitContestant,
    SubmitFiles,
    SendEmail,
} from "../../actions/front_actions";
import Submitbutton from "./Submitbutton.jsx";
import LimitMessage from "./LimitMessage.jsx";
import { addHours } from "date-fns";
import dateFormat from "dateformat";
import CustomReactValidator from "../CustomReactValidator.jsx";

class Submitform extends Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: "",
            open: "",
            show_term: false,
            contestant: [],
            wait: 0,
            file_upl: false,
            new_entry: null,
            sucess_contest: 0,
            uploadedBytes: [],
            totalBytes: [],
            fileName: [],
            status: [],
            uploadsucess: [],
            totalupload: 0,
            file_sys_name: null,
            btn_loader: 0,
            openError: 0,
        };
        const { t } = this.props;

        this.validator = new CustomReactValidator({
            validators: {
                file_react: {
                    // name the rule
                    message: t("file_format_validation"),
                    rule: (file, params, validator) => {
                        if (typeof file === "object") {
                            var sys_name = params.pop();

                            let par = params.filter(String);
                            if (
                                par.length !== 0 &&
                                par[0] != "null" &&
                                par[0] != ""
                            ) {
                                let file_type = file["type"].split("/");
                                let extension = file_type.pop();
                                return par.includes(extension);
                            } else {
                                if (sys_name == "contestant-image")
                                    return (
                                        file &&
                                        file["type"].split("/")[0] === "image"
                                    );
                                else if (
                                    sys_name == "contestant-ow_music_url"
                                ) {
                                    return (
                                        file &&
                                        file["type"].split("/")[0] === "audio"
                                    );
                                } else if (
                                    sys_name == "contestant-ow_video_upload_url"
                                ) {
                                    return (
                                        file &&
                                        file["type"].split("/")[0] === "video"
                                    );
                                }
                            }
                        }
                    },
                    messageReplace: (message, params) => {
                        return message.replace(":values", params);
                    }, // optional
                    required: true, // optional
                },
                file_size: {
                    // name the rule
                    message: t("file_size_validation"),
                    rule: (file, params, validator) => {
                        if (typeof file === "object") {
                            if (params[0] != "0" && params[0]) {
                                const upload_size = file["size"] / 1024 / 1024;
                                return upload_size <= params[0];
                            }
                        }
                        return true;
                    },
                    messageReplace: (message, params) => {
                        return message.replace(":values", params[0]);
                    }, // optional
                },
                desc_char_limit: {
                    message: t("char_limit_validation"),
                    rule: (val, params, validator) => {
                        const charCount = val.replace(
                            /(<([^>]+)>)/gi,
                            ""
                        ).length;
                        return charCount > params[0] ? false : true;
                    },
                    messageReplace: (message, params) => {
                        return message.replace(":values", params);
                    },
                    required: true,
                },
                word_limit: {
                    message: t("word_limit_validation"),
                    rule: (val, params, validator) => {
                        const charCount = val.split(" ").length;
                        return charCount > params[0] ? false : true;
                    },
                    messageReplace: (message, params) => {
                        return message.replace(":values", params);
                    },
                    required: true,
                },
            },
        });
        this.handleupload = this.handleupload.bind(this);
    }

    handleterms = (event) => {
        this.setState({ show_term: true });
    };

    submitForm = () => {
        //console.log(this.validator.getErrorMessages());
        if (this.validator.allValid()) {
            this.setState({ wait: 0 });
            const {
                ow_category_paypal_settings,
                ow_category_stripe_settings,
                ow_category_paystack_settings,
                ow_category_coinbase_settings,
            } = this.props.selcategoryoptions;
            //Send USER DATA
            const userdata = {
                user_id_profile: this.props.short.user_id_profile,
                user_logged: this.props.short.user_logged,
            };

            if (
                ow_category_paypal_settings === "on" ||
                ow_category_stripe_settings === "on" ||
                ow_category_paystack_settings === "on" ||
                ow_category_coinbase_settings === "on"
            ) {
                this.props.paymentchange("payment_entry_open", true);
            } else {
                this.setState({ btn_loader: 1 });
                if (typeof this.props.selcategory !== "undefined") {
                    this.props.SubmitContestant(
                        this.props.SITE_URL,
                        this.props.selcategory,
                        this.props.contestant_form,
                        userdata
                    );
                } else {
                    this.props.SubmitContestant(
                        this.props.SITE_URL,
                        this.props.short.id,
                        this.props.contestant_form,
                        userdata
                    );
                }
            }
            this.setState({ wait: 1 });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    };

    componentWillReceiveProps(nextProps) {
        let inserted = nextProps.new_post_id;
        if (typeof inserted !== "undefined") {
            this.setState({ file_upl: true });
            this.setState({ new_entry: inserted });
            this.handleupload(nextProps, this);
        }
    }

    handleupload = (nextProps, evnt) => {
        const file_field_name = nextProps.file_sys_name;
        const form_val = nextProps.contestant_form;
        const inserted = nextProps.new_post_id;
        const use_tus_upload = nextProps.use_tus_upload;

        //For state values
        const filname_state = [];
        const upl_progress_state = [];
        const totalupl_state = [];
        const uplstatus_state = [];
        const uplsuc_state = [];
        if (typeof file_field_name !== "undefined") {
            let total_upl_len = file_field_name.length;
            if (total_upl_len == 0) {
                evnt.setState({ sucess_contest: 1 });
                return;
            }
            evnt.setState({ totalupload: total_upl_len });
            Object.values(file_field_name).map(function (item) {
                let file_val = form_val[item.system_name];
                if (!file_val) {
                    total_upl_len--;
                    // let formIndex = file_field_name.indexOf(item.system_name);
                    let formIndex = -1;
                    file_field_name.some(function (el, index) {
                        if (el.system_name === item.system_name) {
                            formIndex = index;
                        }
                        return el.system_name === item.system_name;
                    });
                    if (formIndex >= 0) {
                        file_field_name.splice(formIndex, 1);
                        if (total_upl_len == 0) {
                            evnt.setState({
                                sucess_contest: 1,
                                totalupload: total_upl_len,
                            });
                            return;
                        }
                    }
                    return;
                }
                if (file_val) {
                    //Set relevant states to show on submit entry
                    filname_state[item.system_name] = file_val.name;
                    upl_progress_state[item.system_name] = 0;
                    totalupl_state[item.system_name] = 100;
                    uplstatus_state[item.system_name] = 0;
                    uplsuc_state[item.system_name] = 0;

                    evnt.setState({
                        file_sys_name: file_field_name,
                        fileName: filname_state,
                        uploadedBytes: upl_progress_state,
                        totalBytes: totalupl_state,
                        status: uplstatus_state,
                        uploadsucess: uplsuc_state,
                    });

                    if (use_tus_upload) {
                        let upload = new Upload(file_val, {
                            endpoint: nextProps.ORIGINAL_URL + "/wp-tus/",
                            retryDelays: [0, 3000, 5000, 10000],
                            metadata: {
                                filename:
                                    "wpvc_media_" +
                                    new Date().getTime() +
                                    "_" +
                                    file_val.name,
                                filetype: file_val.type,
                                post_id: inserted,
                                system_name: item.system_name,
                            },
                            onError: function (error) {
                                total_upl_len--;
                                console.log("Failed because: " + error);

                                uplstatus_state[item.system_name] =
                                    nextProps.t("upload_failed");
                                uplsuc_state[item.system_name] = 0;
                                evnt.setState({
                                    btn_loader: 0,
                                    openError: 1,
                                    status: uplstatus_state,
                                    uploadsucess: uplsuc_state,
                                    totalupload: 0,
                                });
                                return false;
                            },
                            onShouldRetry: function (
                                err,
                                retryAttempt,
                                options
                            ) {
                                var status = err.originalResponse
                                    ? err.originalResponse.getStatus()
                                    : 0;
                                // Do not retry if the status is a 403. File too large 413
                                if (status === 403 || status === 413) {
                                    return false;
                                }

                                // For any other status code, we retry.
                                return true;
                            },
                            onProgress: function (bytesUploaded, bytesTotal) {
                                var percentage = (
                                    (bytesUploaded / bytesTotal) *
                                    100
                                ).toFixed(2);
                                upl_progress_state[item.system_name] =
                                    Math.round(percentage);
                                evnt.setState({
                                    uploadedBytes: upl_progress_state,
                                });
                            },
                            onSuccess: function () {
                                total_upl_len--;
                                uplsuc_state[item.system_name] = 1;
                                uplstatus_state[item.system_name] = "100%";
                                evnt.setState({
                                    uploadsucess: uplsuc_state,
                                    totalupload: total_upl_len,
                                    status: uplstatus_state,
                                });
                                if (
                                    total_upl_len == 0 &&
                                    evnt.state.openError == 0
                                ) {
                                    evnt.setState({ sucess_contest: 1 });
                                    evnt.handlemodalClose();
                                }
                            },
                        });
                        // Start the upload
                        upload.start();
                    } else {
                        const formData = new FormData();
                        formData.append("file", file_val);
                        // formData.append('filename', "wpvc_media_" + new Date().getTime() + '_' + file_val.name);
                        // formData.append('filetype', file_val.type);
                        formData.append("post_id", inserted);
                        formData.append("system_name", item.system_name);

                        const HASH = Cookies.get("wpvc_voting_authorize");
                        let dataURL =
                            evnt.props.SITE_URL +
                            "wpvc-voting/v1/wpvcuploadfiles";

                        axios
                            .post(dataURL, formData, {
                                headers: {
                                    "Authorize-wpvc": HASH,
                                    "Authorize-wpvc-request": "xmlhttprequest",
                                },
                                onUploadProgress: (progressEvent) => {
                                    var percentage = (
                                        (progressEvent.loaded /
                                            progressEvent.total) *
                                        100
                                    ).toFixed(2);
                                    upl_progress_state[item.system_name] =
                                        Math.round(percentage);
                                    evnt.setState({
                                        uploadedBytes: upl_progress_state,
                                    });
                                },
                            })
                            .then(function (response) {
                                if (response.data.success) {
                                    total_upl_len--;
                                    uplsuc_state[item.system_name] = 1;
                                    upl_progress_state[item.system_name] = 100;
                                    uplstatus_state[item.system_name] = "100%";
                                    evnt.setState({
                                        uploadedBytes: upl_progress_state,
                                        status: uplstatus_state,
                                        uploadsucess: uplsuc_state,
                                        totalupload: total_upl_len,
                                    });
                                    if (total_upl_len == 0) {
                                        evnt.setState({ sucess_contest: 1 });
                                        evnt.handlemodalClose();
                                    }
                                } else {
                                    uplstatus_state[item.system_name] =
                                        response.data.error_message;
                                    uplsuc_state[item.system_name] = 0;
                                    upl_progress_state[item.system_name] = 0;
                                    evnt.setState({
                                        btn_loader: 0,
                                        openError: 1,
                                        uploadedBytes: upl_progress_state,
                                        status: uplstatus_state,
                                        uploadsucess: uplsuc_state,
                                        totalupload: 0,
                                    });
                                    return false;
                                }
                            })
                            .catch(function (error) {
                                console.log(error);
                                uplstatus_state[item.system_name] =
                                    error.message;
                                uplsuc_state[item.system_name] = 0;
                                evnt.setState({
                                    btn_loader: 0,
                                    openError: 1,
                                    status: uplstatus_state,
                                    uploadsucess: uplsuc_state,
                                    totalupload: 0,
                                });
                                return false;
                            });
                    }
                }
            });
        }
        return;
    };

    handleClose = (event) => {
        this.setState({ show_term: false });
    };

    handlemodalClose = (event) => {
        this.setState({ file_upl: false });
    };

    handleErrorClose = (event) => {
        this.setState({ openError: 0 });
    };

    handlemodalsuccess = (event) => {
        //Send USER DATA for Email
        const userdata = {
            user_id_profile: this.props.short.user_id_profile,
            user_logged: this.props.short.user_logged,
        };
        let gateway = "";
        if (this.props.wpvc_current_gateway !== undefined) {
            gateway = this.props.wpvc_current_gateway;
        }
        //If Coinbase Gateway Do not send Email
        if (gateway !== "coinbase") {
            const inserted_data = this.props.contestant_form;
            const new_post_id = this.props.new_post_id;
            this.props.SendEmail(
                this.props.SITE_URL,
                new_post_id,
                userdata,
                inserted_data,
                gateway
            );
        }

        this.setState({ sucess_contest: 0 });

        if (
            gateway != "" &&
            wp.hooks.hasAction(
                "wpvc_submit_redirect",
                "wpvc_paidentry_settings"
            )
        ) {
            wp.hooks.doAction("wpvc_submit_redirect", this.props);
        } else {
            setTimeout(window.location.reload.bind(window.location), 2000);
        }
    };

    isFileImage = (file) => {
        if (typeof file === "object") {
            return file && file["type"].split("/")[0] === "image";
        }
    };

    isImageupdated = (file, system_name) => {
        if (typeof file === "object") {
            let check_names =
                this.state[system_name + "_filename"] == file["name"]
                    ? false
                    : true;
            if (typeof this.state[system_name] === "undefined" || check_names) {
                var obj = {};
                obj[system_name] = URL.createObjectURL(file);
                obj[system_name + "_filename"] = file["name"];
                this.setState(obj);
            }
            return true;
        }
    };

    calculateVoteTimeLeft(start_time, pause_voting_hours = 0) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (start_time != null) {
            start_time = start_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(start_time);
            let difference =
                addHours(new Date(start_Date), pause_voting_hours) -
                current_date;
            return difference;
        } else {
            return -1;
        }
    }

    render() {
        const { t } = this.props;
        const custom = this.props.custom_field;
        const allprops = this.props;
        let end_time = this.props.short.end_time;
        let timer = null;
        if (end_time) {
            timer = this.calculateVoteTimeLeft(end_time);
        }
        const open = Boolean(this.state.show_term);
        const contestant_form = this.props.contestant_form;

        const { votes_navigationbgcolor, votes_formbgcolor, votes_formborder } =
            this.props.settings.color;
        const { wpvc_video_extension } = this.props.settings;
        const config = {
            buttons: [
                "bold",
                "strikethrough",
                "underline",
                "italic",
                "|",
                "ul",
                "ol",
                "|",
                "outdent",
                "indent",
                "|",
                "fontsize",
                "brush",
                "paragraph",
                "|",
                "image",
                "table",
                "link",
                "|",
                "align",
                "|",
                "hr",
            ],
            buttonsMD: [
                "bold",
                "strikethrough",
                "underline",
                "italic",
                "|",
                "ul",
                "ol",
                "|",
                "outdent",
                "indent",
                "|",
                "fontsize",
                "brush",
                "paragraph",
                "|",
                "image",
                "table",
                "link",
                "|",
                "align",
                "|",
                "hr",
            ],
            buttonsSM: [
                "bold",
                "strikethrough",
                "underline",
                "italic",
                "|",
                "ul",
                "ol",
                "|",
                "outdent",
                "indent",
                "|",
                "fontsize",
                "brush",
                "paragraph",
                "|",
                "image",
                "table",
                "link",
                "|",
                "align",
                "|",
                "hr",
            ],
            readonly: false,
            askBeforePasteHTML: false,
            askBeforePasteFromWord: false,
        };
        //On files upload
        const file_field_name = this.state.file_sys_name;

        this.validator.purgeFields();
        let ow_video_upload_url = "";
        if (contestant_form["contestant-ow_video_upload_url"] !== undefined)
            ow_video_upload_url =
                contestant_form["contestant-ow_video_upload_url"];

        let ow_video_url = "";
        if (contestant_form["contestant-ow_video_url"] !== undefined)
            ow_video_url = contestant_form["contestant-ow_video_url"];

        let select_video = false;
        if (ow_video_upload_url == "" && ow_video_url == "") {
            select_video = true;
        }

        //On all category upload
        let all_category = null;
        let category_dropdown = null;
        if (typeof this.props.short.allcategory !== "undefined") {
            all_category = this.props.short.allcategory;
            const taxonomy = allprops.taxonomy ? allprops.taxonomy : [];
            category_dropdown = Object.keys(taxonomy).map((key) => {
                let timer_cat = null;
                let tax_activationcount =
                    taxonomy[key].tax_activationcount || 0;
                if (taxonomy[key].votes_starttime) {
                    timer_cat = this.calculateVoteTimeLeft(
                        taxonomy[key].votes_starttime,
                        taxonomy[key].pause_voting
                    );
                } else if (taxonomy[key].votes_expiration) {
                    timer_cat = this.calculateVoteTimeLeft(
                        taxonomy[key].votes_expiration
                    );
                }

                if (
                    ((timer_cat != null && timer_cat > 0) ||
                        timer_cat == null) &&
                    (tax_activationcount == 0 ||
                        (tax_activationcount != 0 &&
                            tax_activationcount >
                                taxonomy[key].published_post_count))
                ) {
                    return (
                        <MenuItem key={key} value={taxonomy[key].term_id}>
                            {taxonomy[key].category_name}
                        </MenuItem>
                    );
                }
            });
        }

        if (
            this.props.short.showform !== "0" &&
            this.props.short.displayform !== "0" &&
            (this.props.short.showform === "1" ||
                this.props.short.displayform === "1" ||
                (custom &&
                    this.state.totalupload == 0 &&
                    (timer > 0 || timer == null)))
        ) {
            return (
                <React.Fragment>
                    {this.state.sucess_contest == 1 && (
                        <Dialog
                            onClose={this.handlemodalsuccess}
                            aria-labelledby="customized-dialog-title"
                            open={true}
                        >
                            <MuiDialogTitle
                                component="div"
                                className="wpvc_submission_popup_title"
                                onClose={this.handlemodalsuccess}
                            >
                                <Typography variant="h6">
                                    {t("success_entry")}
                                </Typography>
                                <IconButton
                                    aria-label="close"
                                    onClick={this.handlemodalsuccess}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </MuiDialogTitle>

                            <MuiDialogContent
                                dividers
                                className="wpvc_submission_popup_content"
                            >
                                <Typography>
                                    {t(this.props.ret_alert)}
                                </Typography>
                            </MuiDialogContent>
                            <DialogActions>
                                <Button
                                    onClick={this.handlemodalsuccess}
                                    color="primary"
                                    autoFocus
                                >
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                    {this.state.openError == 1 && (
                        <Dialog
                            onClose={this.handleErrorClose}
                            aria-labelledby="customized-dialog-title"
                            open={this.state.openError}
                        >
                            <MuiDialogTitle
                                component="div"
                                className="wpvc_progress_popup_title"
                                onClose={this.handleErrorClose}
                            >
                                <Typography variant="h6">
                                    {t("upload_failed")}
                                </Typography>
                            </MuiDialogTitle>

                            <MuiDialogContent
                                dividers
                                className="wpvc_progress_popup_content"
                            >
                                {file_field_name?.map((item, key) => (
                                    <Grid2
                                        key={key}
                                        className="wpvc_upload_content_progress"
                                        size={12}
                                    >
                                        <Typography>
                                            {t("file_name")}
                                            {
                                                this.state.fileName[
                                                    item.system_name
                                                ]
                                            }
                                        </Typography>
                                        <Box alignItems="center">
                                            <Box width="100%" mr={1}>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={
                                                        this.state
                                                            .uploadedBytes[
                                                            item.system_name
                                                        ]
                                                    }
                                                />
                                            </Box>
                                            <Box>
                                                <Typography color="error">
                                                    {
                                                        this.state.status[
                                                            item.system_name
                                                        ]
                                                    }
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid2>
                                ))}
                            </MuiDialogContent>
                            <DialogActions>
                                <Button
                                    onClick={this.handleErrorClose}
                                    color="primary"
                                    autoFocus
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}
                    <form
                        id="add_contestant"
                        name="myForm"
                        encType="multipart/form-data"
                    >
                        <Grid2
                            container
                            size={12}
                            direction="column"
                            className="wpvc_submit_form"
                            style={{
                                backgroundColor:
                                    votes_formbgcolor ||
                                    LightenDarkenColor(
                                        votes_navigationbgcolor,
                                        195
                                    ),
                                border:
                                    "1px solid " + votes_formborder ||
                                    votes_navigationbgcolor,
                                color: votes_navigationbgcolor,
                            }}
                        >
                            {all_category == 1 && (
                                <Grid2
                                    container
                                    className="wpvc_submit_form_field"
                                    size={12}
                                >
                                    <Grid2 className="wpvc_label" size={12}>
                                        <Typography>
                                            {t("select_add_category")}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 className="wpvc_form_grid" size={12}>
                                        <FormControl
                                            fullWidth
                                            className="wpvc_form_control_ad"
                                        >
                                            <Select
                                                variant="standard"
                                                name="all_category_drop"
                                                onChange={this.props.catchange(
                                                    "contestant_form"
                                                )}
                                                value={
                                                    this.props.selcategory || ""
                                                }
                                            >
                                                {category_dropdown ? (
                                                    category_dropdown
                                                ) : (
                                                    <MenuItem value={key}>
                                                        {t("select")}
                                                    </MenuItem>
                                                )}
                                            </Select>
                                            {this.validator.message(
                                                t("select_add_category"),
                                                this.props.selcategory,
                                                "required"
                                            )}
                                        </FormControl>
                                    </Grid2>
                                </Grid2>
                            )}

                            {all_category == 1 &&
                                this.props.checklimit !== 0 && (
                                    <LimitMessage setopen={1} />
                                )}

                            {(all_category == 1 &&
                                this.props.checklimit !== 0) ||
                                custom.map((item, index) => (
                                    <Grid2
                                        key={index}
                                        container
                                        className="wpvc_submit_form_field"
                                        size={12}
                                    >
                                        {item.question_type != "TERMS" && (
                                            <Grid2
                                                className="wpvc_label"
                                                size={12}
                                            >
                                                <Typography>
                                                    {item.question}
                                                </Typography>
                                            </Grid2>
                                        )}
                                        <Grid2
                                            className="wpvc_form_grid"
                                            size={12}
                                        >
                                            {item.question_type == "TEXT" &&
                                                item.system_name !=
                                                    "contestant-desc" && (
                                                    <FormControl
                                                        fullWidth
                                                        className="wpvc_form_control_ad"
                                                    >
                                                        <TextField
                                                            variant="standard"
                                                            type={
                                                                item
                                                                    .react_values
                                                                    .text_field_type
                                                            }
                                                            name={
                                                                item.system_name
                                                            }
                                                            value={
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ] || ""
                                                            }
                                                            label={
                                                                item.description
                                                            }
                                                            onChange={this.props.valchange(
                                                                "contestant_form"
                                                            )}
                                                        />

                                                        {item.system_name !=
                                                            "contestant-ow_video_url" &&
                                                            item.required ==
                                                                "Y" &&
                                                            this.validator.message(
                                                                item.required_text !=
                                                                    null &&
                                                                    item.required_text !=
                                                                        ""
                                                                    ? item.required_text
                                                                    : t(
                                                                          "enter_the"
                                                                      ) +
                                                                          item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "required"
                                                            )}
                                                        {item.system_name ==
                                                            "contestant-ow_video_url" &&
                                                            select_video ==
                                                                true &&
                                                            this.validator.message(
                                                                item.required_text !=
                                                                    null &&
                                                                    item.required_text !=
                                                                        ""
                                                                    ? item.required_text
                                                                    : t(
                                                                          "enter_the"
                                                                      ) +
                                                                          item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "required"
                                                            )}

                                                        {item.system_name ==
                                                            "contestant-title" &&
                                                            item.set_limit ==
                                                                "Y" &&
                                                            item.limit_type ==
                                                                "N" &&
                                                            this.validator.message(
                                                                t(
                                                                    "char_limit_validation"
                                                                ),
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "desc_char_limit:" +
                                                                    item.limit_count
                                                            )}
                                                        {item.system_name ==
                                                            "contestant-title" &&
                                                            item.set_limit ==
                                                                "Y" &&
                                                            item.limit_type ==
                                                                "Y" &&
                                                            this.validator.message(
                                                                t(
                                                                    "word_limit_validation"
                                                                ),
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "word_limit:" +
                                                                    item.limit_count
                                                            )}
                                                    </FormControl>
                                                )}

                                            {item.system_name ==
                                                "contestant-desc" && (
                                                <FormControl
                                                    fullWidth
                                                    className="wpvc_form_control_ad"
                                                >
                                                    <FormLabel
                                                        component="legend"
                                                        className="wpvc_submit_description"
                                                    >
                                                        {item.description}
                                                    </FormLabel>
                                                    <JoditEditor
                                                        editorRef="response"
                                                        name={item.system_name}
                                                        value={
                                                            contestant_form[
                                                                item.system_name
                                                            ] || ""
                                                        }
                                                        config={config}
                                                        onBlur={this.props.ediorchange(
                                                            item.system_name
                                                        )}
                                                    />

                                                    {item.required == "Y" &&
                                                        this.validator.message(
                                                            item.required_text !=
                                                                null &&
                                                                item.required_text !=
                                                                    ""
                                                                ? item.required_text
                                                                : t(
                                                                      "enter_the"
                                                                  ) +
                                                                      item.question,
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "required"
                                                        )}

                                                    {item.system_name ==
                                                        "contestant-desc" &&
                                                        item.set_limit == "Y" &&
                                                        item.limit_type ==
                                                            "N" &&
                                                        this.validator.message(
                                                            t(
                                                                "char_limit_validation"
                                                            ),
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "desc_char_limit:" +
                                                                item.limit_count
                                                        )}
                                                    {item.system_name ==
                                                        "contestant-desc" &&
                                                        item.set_limit == "Y" &&
                                                        item.limit_type ==
                                                            "Y" &&
                                                        this.validator.message(
                                                            t(
                                                                "word_limit_validation"
                                                            ),
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "word_limit:" +
                                                                item.limit_count
                                                        )}
                                                </FormControl>
                                            )}

                                            {item.question_type == "TEXTAREA" &&
                                                item.system_name !=
                                                    "contestant-desc" && (
                                                    <FormControl
                                                        fullWidth
                                                        className="wpvc_form_control_ad"
                                                    >
                                                        <TextareaAutosize
                                                            name={
                                                                item.system_name
                                                            }
                                                            minRows={
                                                                item
                                                                    .react_values
                                                                    .text_area_row
                                                            }
                                                            value={
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ] || ""
                                                            }
                                                            placeholder={
                                                                item.description
                                                            }
                                                            onChange={this.props.valchange(
                                                                "contestant_form"
                                                            )}
                                                        />

                                                        {item.required == "Y" &&
                                                            this.validator.message(
                                                                item.required_text !=
                                                                    null &&
                                                                    item.required_text !=
                                                                        ""
                                                                    ? item.required_text
                                                                    : t(
                                                                          "enter_the"
                                                                      ) +
                                                                          item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "required"
                                                            )}
                                                    </FormControl>
                                                )}

                                            {item.question_type == "SINGLE" && (
                                                <FormControl
                                                    fullWidth
                                                    className="wpvc_form_control_ad"
                                                    component="fieldset"
                                                >
                                                    <FormLabel
                                                        component="legend"
                                                        className="wpvc_submit_description"
                                                    >
                                                        {item.description}
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="vote_votingtype"
                                                        name={item.system_name}
                                                        onChange={this.props.valchange(
                                                            "contestant_form"
                                                        )}
                                                    >
                                                        {Object.keys(
                                                            item.drop_values
                                                        ).map((key) => (
                                                            <FormControlLabel
                                                                key={key}
                                                                className="wpvc_submit_label"
                                                                control={
                                                                    <Radio color="primary" />
                                                                }
                                                                value={
                                                                    item
                                                                        .drop_values[
                                                                        key
                                                                    ]
                                                                }
                                                                label={
                                                                    item
                                                                        .drop_values[
                                                                        key
                                                                    ]
                                                                }
                                                                labelPlacement={
                                                                    item
                                                                        .react_values
                                                                        .value_placement
                                                                }
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                    {item.required == "Y" &&
                                                        this.validator.message(
                                                            item.required_text !=
                                                                null &&
                                                                item.required_text !=
                                                                    ""
                                                                ? item.required_text
                                                                : t(
                                                                      "enter_the"
                                                                  ) +
                                                                      item.question,
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "required"
                                                        )}
                                                </FormControl>
                                            )}

                                            {item.question_type ==
                                                "DROPDOWN" && (
                                                <FormControl
                                                    fullWidth
                                                    className="wpvc_form_control_ad"
                                                >
                                                    <InputLabel
                                                        id={
                                                            "contest-" +
                                                            item.system_name
                                                        }
                                                    >
                                                        {item.description}
                                                    </InputLabel>
                                                    <Select
                                                        variant="standard"
                                                        name={item.system_name}
                                                        labelId={
                                                            "contest-" +
                                                            item.system_name
                                                        }
                                                        displayEmpty
                                                        className="wpvc_submit_select"
                                                        onChange={this.props.valchange(
                                                            "contestant_form"
                                                        )}
                                                    >
                                                        {Object.keys(
                                                            item.drop_values
                                                        ).map((key) => (
                                                            <MenuItem
                                                                key={key}
                                                                value={
                                                                    item
                                                                        .drop_values[
                                                                        key
                                                                    ]
                                                                }
                                                            >
                                                                {
                                                                    item
                                                                        .drop_values[
                                                                        key
                                                                    ]
                                                                }
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {item.required == "Y" &&
                                                        this.validator.message(
                                                            item.required_text !=
                                                                null &&
                                                                item.required_text !=
                                                                    ""
                                                                ? item.required_text
                                                                : t(
                                                                      "enter_the"
                                                                  ) +
                                                                      item.question,
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "required"
                                                        )}
                                                </FormControl>
                                            )}

                                            {item.question_type ==
                                                "MULTIPLE" && (
                                                <FormControl
                                                    component="fieldset"
                                                    fullWidth
                                                    className="wpvc_form_control_ad"
                                                >
                                                    <FormLabel
                                                        component="legend"
                                                        className="wpvc_submit_description"
                                                    >
                                                        {item.description}
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="vote_votingtype"
                                                    >
                                                        {Object.keys(
                                                            item.drop_values
                                                        ).map((key) => (
                                                            <FormControlLabel
                                                                key={key}
                                                                className="wpvc_submit_label"
                                                                control={
                                                                    <Checkbox
                                                                        color="primary"
                                                                        name={
                                                                            item.system_name
                                                                        }
                                                                        onChange={this.props.checkboxchange(
                                                                            "contestant_form"
                                                                        )}
                                                                    />
                                                                }
                                                                value={
                                                                    item
                                                                        .drop_values[
                                                                        key
                                                                    ]
                                                                }
                                                                label={
                                                                    item
                                                                        .drop_values[
                                                                        key
                                                                    ]
                                                                }
                                                                labelPlacement={
                                                                    item
                                                                        .react_values
                                                                        .value_placement
                                                                }
                                                            />
                                                        ))}
                                                    </RadioGroup>
                                                    {item.required == "Y" &&
                                                        this.validator.message(
                                                            item.required_text !=
                                                                null &&
                                                                item.required_text !=
                                                                    ""
                                                                ? item.required_text
                                                                : t(
                                                                      "enter_the"
                                                                  ) +
                                                                      item.question,
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "required"
                                                        )}
                                                </FormControl>
                                            )}
                                            {item.question_type == "TERMS" && (
                                                <FormControl
                                                    component="fieldset"
                                                    fullWidth
                                                    className="wpvc_form_control_ad"
                                                >
                                                    <FormLabel
                                                        component="legend"
                                                        className="wpvc_submit_description"
                                                    >
                                                        {item.description}
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-label="vote_votingtype"
                                                        className="wpvc_terms_checkbox"
                                                    >
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    color="primary"
                                                                    name={
                                                                        item.system_name
                                                                    }
                                                                    value={
                                                                        contestant_form[
                                                                            item
                                                                                .system_name
                                                                        ] ==
                                                                        "on"
                                                                            ? "off"
                                                                            : "on"
                                                                    }
                                                                    onChange={this.props.valchange(
                                                                        "contestant_form"
                                                                    )}
                                                                />
                                                            }
                                                        />
                                                        <Button
                                                            className="wpvc_terms_submit"
                                                            color="primary"
                                                            component="a"
                                                            onClick={() => {
                                                                this.handleterms();
                                                            }}
                                                        >
                                                            {item.question}
                                                        </Button>
                                                        {item.required == "Y" &&
                                                            this.validator.message(
                                                                item.required_text !=
                                                                    null &&
                                                                    item.required_text !=
                                                                        ""
                                                                    ? item.required_text
                                                                    : t(
                                                                          "enter_the"
                                                                      ) +
                                                                          item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "required"
                                                            )}
                                                    </RadioGroup>
                                                </FormControl>
                                            )}

                                            {item.question_type == "TERMS" && (
                                                <Dialog
                                                    onClose={this.handleClose}
                                                    aria-labelledby="customized-dialog-title"
                                                    open={this.state.show_term}
                                                >
                                                    <MuiDialogTitle
                                                        component="div"
                                                        className="wpvc_terms_popup_title"
                                                        onClose={
                                                            this.handleClose
                                                        }
                                                    >
                                                        <Typography variant="h6">
                                                            {t(
                                                                "termsandconditions"
                                                            )}
                                                        </Typography>
                                                        <IconButton
                                                            aria-label="close"
                                                            onClick={
                                                                this.handleClose
                                                            }
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </MuiDialogTitle>
                                                    <MuiDialogContent
                                                        dividers
                                                        className="wpvc_terms_popup_content"
                                                    >
                                                        {ReactHtmlParser(
                                                            item.response
                                                        )}
                                                    </MuiDialogContent>
                                                </Dialog>
                                            )}

                                            {item.question_type == "FILE" && (
                                                <div className="wpvc_form_control_ad">
                                                    <FormLabel
                                                        component="legend"
                                                        className="wpvc_submit_description"
                                                    >
                                                        {item.description}
                                                    </FormLabel>
                                                    <input
                                                        id={
                                                            this.props.short
                                                                .id +
                                                            "_" +
                                                            item.system_name
                                                        }
                                                        name={item.system_name}
                                                        type="file"
                                                        style={{
                                                            display: "none",
                                                        }}
                                                        onChange={this.props.filechange(
                                                            "contestant_form"
                                                        )}
                                                    />
                                                    <label
                                                        htmlFor={
                                                            this.props.short
                                                                .id +
                                                            "_" +
                                                            item.system_name
                                                        }
                                                    >
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            className="wpvc_btn_submit_form"
                                                            component="span"
                                                            startIcon={
                                                                <Icon>
                                                                    {
                                                                        item
                                                                            .react_values
                                                                            .upload_icon
                                                                    }
                                                                </Icon>
                                                            }
                                                        >
                                                            {t(
                                                                "upload_button_text"
                                                            )}
                                                        </Button>
                                                        {/* Required validation */}
                                                        {item.system_name !=
                                                            "contestant-ow_video_upload_url" &&
                                                            item.required ==
                                                                "Y" &&
                                                            this.validator.message(
                                                                item.required_text !=
                                                                    null &&
                                                                    item.required_text !=
                                                                        ""
                                                                    ? item.required_text
                                                                    : t(
                                                                          "enter_the"
                                                                      ) +
                                                                          item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "required"
                                                            )}
                                                        {/* Format validation */}
                                                        {item.system_name !=
                                                            "contestant-ow_video_upload_url" &&
                                                            this.validator.message(
                                                                item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "file_react:" +
                                                                    item.response +
                                                                    "," +
                                                                    item.system_name +
                                                                    "|" +
                                                                    "file_size:" +
                                                                    item.ow_file_size
                                                            )}

                                                        {/* Video Format validation */}
                                                        {item.system_name ==
                                                            "contestant-ow_video_upload_url" &&
                                                            contestant_form[
                                                                item.system_name
                                                            ] &&
                                                            this.validator.message(
                                                                item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "file_react:" +
                                                                    item.response +
                                                                    "," +
                                                                    item.system_name +
                                                                    "|" +
                                                                    "file_size:" +
                                                                    item.ow_file_size
                                                            )}
                                                        {/* Video Required validation */}
                                                        {item.system_name ==
                                                            "contestant-ow_video_upload_url" &&
                                                            select_video ==
                                                                true &&
                                                            this.validator.message(
                                                                item.required_text !=
                                                                    null &&
                                                                    item.required_text !=
                                                                        ""
                                                                    ? item.required_text
                                                                    : t(
                                                                          "enter_the"
                                                                      ) +
                                                                          item.question,
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ],
                                                                "required"
                                                            )}
                                                    </label>
                                                    {this.isFileImage(
                                                        contestant_form[
                                                            item.system_name
                                                        ]
                                                    ) == true && (
                                                        <CardMedia
                                                            className="wpvc_submit_display_image"
                                                            image={URL.createObjectURL(
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ]
                                                            )}
                                                        />
                                                    )}
                                                    {this.isFileImage(
                                                        contestant_form[
                                                            item.system_name
                                                        ]
                                                    ) == false && (
                                                        <Typography>
                                                            {
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ].name
                                                            }
                                                        </Typography>
                                                    )}
                                                </div>
                                            )}

                                            {item.question_type == "DATE" && (
                                                <FormControl
                                                    component="fieldset"
                                                    fullWidth
                                                    className="wpvc_form_control_ad wpvc_form_datepicker"
                                                >
                                                    <LocalizationProvider
                                                        dateAdapter={
                                                            AdapterDateFns
                                                        }
                                                    >
                                                        <DatePicker
                                                            className="wpvc_datepicker"
                                                            label={
                                                                item.description
                                                            }
                                                            value={
                                                                contestant_form[
                                                                    item
                                                                        .system_name
                                                                ]
                                                                    ? contestant_form[
                                                                          item
                                                                              .system_name
                                                                      ]
                                                                    : new Date()
                                                            }
                                                            onChange={this.props.datepickerchange(
                                                                "contestant_form" +
                                                                    "--" +
                                                                    item.system_name
                                                            )}
                                                            format={
                                                                item
                                                                    .react_values
                                                                    .datepicker_only
                                                            }
                                                        />
                                                    </LocalizationProvider>
                                                    {item.required == "Y" &&
                                                        this.validator.message(
                                                            item.required_text !=
                                                                null &&
                                                                item.required_text !=
                                                                    ""
                                                                ? item.required_text
                                                                : t(
                                                                      "enter_the"
                                                                  ) +
                                                                      item.question,
                                                            contestant_form[
                                                                item.system_name
                                                            ],
                                                            "required"
                                                        )}
                                                </FormControl>
                                            )}
                                        </Grid2>
                                    </Grid2>
                                ))}

                            {all_category == 1 &&
                                this.props.selcategory != null &&
                                this.props.selcategoryoptions != null &&
                                wp.hooks.applyFilters(
                                    "wpvc_submit_entry_btn",
                                    <Submitbutton
                                        {...allprops}
                                        btn_loader={this.state.btn_loader}
                                        ORIGINAL_URL={this.props.ORIGINAL_URL}
                                        saveform={this.submitForm}
                                    />,
                                    this.props
                                )}

                            {all_category == null &&
                                this.props.currentcat == null &&
                                wp.hooks.applyFilters(
                                    "wpvc_submit_entry_btn",
                                    <Submitbutton
                                        {...allprops}
                                        btn_loader={this.state.btn_loader}
                                        ORIGINAL_URL={this.props.ORIGINAL_URL}
                                        saveform={this.submitForm}
                                    />,
                                    this.props
                                )}
                        </Grid2>
                    </form>
                </React.Fragment>
            );
        } else if (
            this.state.totalupload != 0 &&
            (timer > 0 || timer == null)
        ) {
            return (
                <React.Fragment>
                    <Dialog
                        onClose={this.handlemodalClose}
                        aria-labelledby="customized-dialog-title"
                        open={this.state.file_upl}
                    >
                        <MuiDialogTitle
                            component="div"
                            className="wpvc_progress_popup_title"
                            onClose={this.handlemodalClose}
                        >
                            <Typography variant="h6">
                                {t("please_wait_until")}
                            </Typography>
                        </MuiDialogTitle>

                        <MuiDialogContent
                            dividers
                            className="wpvc_progress_popup_content"
                        >
                            <Typography>{t("please_wait_uploads")}</Typography>
                            {file_field_name?.map((item, key) => (
                                <Grid2
                                    key={key}
                                    className="wpvc_upload_content_progress"
                                    size={12}
                                >
                                    <Typography>
                                        {t("file_name")}
                                        {this.state.fileName[item.system_name]}
                                    </Typography>
                                    <Box display="flex" alignItems="center">
                                        <Box width="100%" mr={1}>
                                            <LinearProgress
                                                variant="determinate"
                                                value={
                                                    this.state.uploadedBytes[
                                                        item.system_name
                                                    ]
                                                }
                                            />
                                        </Box>
                                        <Box minWidth={35}>
                                            <Typography
                                                variant="body2"
                                                color="textSecondary"
                                            >
                                                {this.state.uploadedBytes[
                                                    item.system_name
                                                ] + "%"}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid2>
                            ))}
                        </MuiDialogContent>
                    </Dialog>
                </React.Fragment>
            );
        } else if (
            timer < 0 ||
            this.props.short.showform == "0" ||
            this.props.short.displayform == "0"
        ) {
            return "";
        } else {
            return (
                <Backdrop className="wpvc_back_loader" open={true}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            );
        }
    }
}

console.warn = () => {};
export default connect("", { SubmitContestant, SubmitFiles, SendEmail })(
    withTranslation("translations")(Submitform)
);
